import { Axios } from '@/config/axios'

const state = {
}

const getters = {
}

const actions = {
    getAlerts ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/alerts?page=${data.page}&perPage=${data.perPage}&agentId=${data.agentId}&ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
